import React from 'react';
import Testimonial from '../components/Testimonial';
import styles from '../styles/Testimonials.module.css';

const Testimonials = () => (
  <main className={styles.page}>
    <Testimonial ctaLabel="Back to home" ctaTo="/" />
  </main>
);

export default Testimonials;
